/**
 * @fileoverview My Timesheet — weekly time entry (MOR-906)
 *
 * URL: /dashboard/timesheets
 * Protection: authenticated.
 *
 * Keyboard-first weekly entry against the active organisation's jobs:
 * 6-minute units, general head categories, PRE/POST project codes, and the
 * draft → submitted → approved lifecycle.
 *
 * Dependencies:
 * - Convex: timesheets.entries.*, timesheets.seed.ensureSeeded
 */

import { createFileRoute } from "@tanstack/react-router";
import { useQuery } from "@tanstack/react-query";
import { convexQuery } from "@convex-dev/react-query";

import { api } from "@cvx/_generated/api";

import { useActiveOrg } from "@/utils/org-context";
import { WeeklyTimesheet } from "@/components/timesheets/WeeklyTimesheet";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/timesheets",
)({
  beforeLoad: () => ({ headerTitle: "Timesheets" }),
  component: TimesheetsPage,
});

function TimesheetsPage() {
  const { orgId, activeOrg } = useActiveOrg();
  const { data: me } = useQuery(
    convexQuery(api.users.queries.getCurrentUser, {}),
  );
  const canClearMissingNotice =
    activeOrg?.role === "owner" || activeOrg?.role === "admin";

  return (
    <div className="flex flex-1 flex-col gap-5 bg-muted p-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">My Timesheets</h1>
        <p className="text-sm text-muted-foreground">
          Record and manage your timesheets across all jobs.
        </p>
      </div>
      {orgId ? (
        <WeeklyTimesheet
          orgId={orgId}
          viewerUserId={me?._id}
          canClearMissingNotice={canClearMissingNotice}
        />
      ) : (
        <div className="text-sm text-muted-foreground">
          Select an organisation to record time.
        </div>
      )}
    </div>
  );
}
